import './App.scss';
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout'
import Home from './components/Home'
import About from './components/About'
import Skills from './components/Skills'
import Contact from './components/contact'
import Cursor from './components/Cursor';
import PreLoader from './components/preLoader';

function App() {
  return (
    <>
    <div>
      <PreLoader/>
      <Cursor />
    </div>
    <Routes>
      <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path='about' element={<About/>} />
      <Route path='contact' element={<Contact/>} />
      <Route path="/skills" element={<Skills />} />
      </Route>
    </Routes>

    </>
  )
}

export default App;
